<script lang="ts">
  import { push } from "svelte-spa-router";
  import { authStateStore, userStore } from "$lib/stores/user";
  import { selectedOrgStore } from "$lib/stores/orgs";
  import { derived } from "svelte/store";

  const nextPath = derived([userStore, selectedOrgStore], ([user, selectedOrg]) => {
    if (selectedOrg) {
      return selectedOrg.pagePrefix;
    } else if (user) {
      if (user.defaultTeam) {
        return `/t/${user.defaultTeam}`;
      }
      if (user.teamClaims.length > 0) {
        return `/t/${user.teamClaims[0].teamId}`;
      }
      if (!user.organisation_setup_id && user.orgClaims.length == 0) {
        return `/onboarding`;
      }
    }
  });

  $effect(() => {
    if ($nextPath) {
      push($nextPath);
    }
  });
</script>

<div class="flex flex-col gap-1">
  <h1 class="font-semibold">Welcome back, {$userStore?.name ?? ""}</h1>
  <p class="text-lg">Let’s start sourcing data. Securely.</p>

  <p class="text-lg">Select or create a team using the sidebar on the right to get started with Permissions Assurance!</p>
</div>
